import { ChangeDetectorRef, Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType, TranslationService } from '@spartacus/core';
import { MyCompanyAccountService } from 'src/app/services/feature/myCompanyAccount/my-company-account.service';
import moment from 'moment';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-kb-manage-registration',
  templateUrl: './kb-manage-registration.component.html',
  styleUrls: ['./kb-manage-registration.component.scss'],
  standalone: false
})
export class KbManageRegistrationComponent {
  userList: any;
  searchTerm: any;
  sortByName: boolean = false;
  sortByNameDesc: boolean = false;
  sortByEmail: boolean = false;
  sortByEmailDesc: boolean = false;
  sortByActive: boolean = false;
  sortByActiveDesc: boolean = false;
  totalResult: any;
  private destroy$ = new Subject<void>();
  constructor(private myCompanyAccountService: MyCompanyAccountService,
    private globalMessageService: GlobalMessageService,
    private cdr: ChangeDetectorRef,
    private router: Router, private translationService: TranslationService,
  ) {

  }

  ngOnInit() {
    this.getRegistrationRequest('', 0, '');
  }

  getRegistrationRequest(searchText?, currentPage?, sortType?) {
    this.myCompanyAccountService.getRegistrationRequests(currentPage, sortType).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      this.userList = data;
      this.translationService.translate('common.text_company_manageUser_registration_totalResults')
        .pipe(takeUntil(this.destroy$)).subscribe((key) => {
          if (key.includes('{0}')) {
            this.totalResult = key.replace('{0}', data?.pagination.totalResults);
          }
        })

      this.cdr.detectChanges();
    })
    this.myCompanyAccountService.createUserGet().pipe(takeUntil(this.destroy$)).subscribe(data => {
    })
  }



  editUser(userId) {
    this.router.navigate(['registration-detail'], {
      queryParams: { user: userId },
    });
  }

  changePageCustom(e, data) {
    this.getRegistrationRequest('', e)
  }

  sort(type) {
    if (type == 'name') {
      if ((!this.sortByName && !this.sortByNameDesc) || this.sortByNameDesc) {
        this.getRegistrationRequest('', 0, 'byName');
        this.sortByName = true;
        this.sortByNameDesc = false;
      } else if (this.sortByName) {
        this.getRegistrationRequest('', 0, 'byNameDesc');
        this.sortByNameDesc = true;
        this.sortByName = false;
      }
      this.sortByEmail = false;
      this.sortByEmailDesc = false;
      this.sortByActive = false;
      this.sortByActiveDesc = false;
    }
    if (type == 'email') {
      if ((!this.sortByEmail && !this.sortByEmailDesc) || this.sortByEmailDesc) {
        this.getRegistrationRequest('', 0, 'byEmail');
        this.sortByEmail = true;
        this.sortByEmailDesc = false;
      } else if (this.sortByEmail) {
        this.getRegistrationRequest('', 0, 'byEmailDesc');
        this.sortByEmail = false;
        this.sortByEmailDesc = true;
      }
      this.sortByNameDesc = false;
      this.sortByName = false;
      this.sortByActive = false;
      this.sortByActiveDesc = false;
    }
    if (type == 'active') {
      if ((!this.sortByActive && !this.sortByActiveDesc) || this.sortByActiveDesc) {
        this.getRegistrationRequest('', 0, 'byActive');
        this.sortByActive = true;
        this.sortByActiveDesc = false;
      } else if (this.sortByActive) {
        this.getRegistrationRequest('', 0, 'byActiveDesc');
        this.sortByActive = false;
        this.sortByActiveDesc = true;
      }
      this.sortByNameDesc = false;
      this.sortByName = false;
      this.sortByEmail = false;
      this.sortByEmailDesc = false;
    }
  }

  retriggerEmail(user) {
    this.myCompanyAccountService.retriggerEmail(user).pipe(takeUntil(this.destroy$)).subscribe((data: any) => {
      if (data.status === 'SUCCESS') {
        let updatedKey = '';
        this.translationService.translate(data?.['message'])
          .pipe(takeUntil(this.destroy$)).subscribe((key) => {
            if (key.includes('{0}')) {
              updatedKey = key.replace('{0}', user);
            }
          })
        this.globalMessageService.add(
          updatedKey, GlobalMessageType.MSG_TYPE_INFO
        );
      }
    })
  }

  formatDate(dateString: string, dateFormat: string) {
    const date = new Date(dateString);
    return moment(date).format(dateFormat.toUpperCase());
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}

